import appConstants from '../../../../../constants';
import { useL18nContext } from '../../../ContextProvider/L18n';
import computeClassName from '../../../../../utils/computeClassName';

const constants = Object.freeze({
  CLASSNAME_BASE: ''
});

function getComputedExpertises(role, expertises) {
  switch (role) {
    case appConstants.VALUE_INTEGRATOR:
      return expertises
        .filter(expertise => (expertise[appConstants.KEY_CATEGORY_DISPLAY_NAME] === appConstants.VALUE_SPECIALIZATIONS)||(expertise[appConstants.KEY_CATEGORY_DISPLAY_NAME] === appConstants.VALUE_PARTNER_SPECIALIZATIONS))
        .map(filteredExpertise => filteredExpertise[appConstants.KEY_KEYWORD_DISPLAY_NAME]);
    case appConstants.VALUE_PROVIDER:
      return expertises
        .filter(expertise => (expertise[appConstants.KEY_CATEGORY_DISPLAY_NAME] === appConstants.VALUE_PROVIDER_LEVEL_AND_CISCO_POWERED_SERVICES) &&
                              !appConstants.PROVIDER_LEVELS.includes(expertise[appConstants.KEY_KEYWORD_DISPLAY_NAME].trim().toLowerCase()))
        .map(filteredExpertise => filteredExpertise[appConstants.KEY_KEYWORD_DISPLAY_NAME]);
      default:
      return []
  }
}

export default function PartnerRoleExpertises(
  {
    role,
    expertises = [],
    className = ''
  }) {
  const { getTranslationFor } = useL18nContext();
  if(!role || (!!expertises && !!expertises.length)) {
    const computedClassName = computeClassName(className, constants.CLASSNAME_BASE);
    const computedExpertises = getComputedExpertises(role, expertises);
    return (
      <section className={computedClassName}>
        {
          !!computedExpertises.length ?
          <>
            <h4 className="text-cc-200 font-light mb-6">{getTranslationFor(appConstants.LABEL_ROLE_QUALIFICATION_NAME_MAPPING[role])} ({computedExpertises.length})</h4>
            <ul className="list-disc list-outside text-cc-body-medium sm:text-cc-body-large text-cc-secondary-contrast ml-3">
              {
                computedExpertises.map((expertise, index) => {
                  return (
                    <li key={index} className="ml-3 pl-1">{expertise}</li>
                  );
                })
              }
            </ul>
          </> :
          <>&nbsp;</>
        }
      </section>
    )
  }
  else {
    return null;
  }
}
